import { useParams } from "react-router-dom";
import { DatasetAssistant } from "datasets/components/assistant/DatasetAssistant";

const DatasetAnalysis = () => {
  const { datasetId } = useParams<{ datasetId: string }>();

  if (!datasetId) {
    return <div>Dataset not found</div>;
  }

  return (
    <div className="h-[calc(100vh-112px)]">
      <DatasetAssistant datasetId={datasetId} mode="embedded" />
    </div>
  );
};

export default DatasetAnalysis;
